import React from "react";
import {css, Theme} from "@emotion/react";

interface IProps {
    x: number;
    y: number;
}

export const MapMarker: React.FC<IProps> = ({x, y}) => {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <path
                d="M7.24984 11.7247C10.0996 11.7247 12.4098 9.41445 12.4098 6.56466C12.4098 3.71487 10.0996 1.40466 7.24984 1.40466C4.40005 1.40466 2.08984 3.71487 2.08984 6.56466C2.08984 9.41445 4.40005 11.7247 7.24984 11.7247Z"
                css={backgroundCirclePath}
            />
            <path
                d="M7.15 0.0150146C5.38448 0.0203086 3.69306 0.725376 2.44652 1.97567C1.19997 3.22596 0.499992 4.91948 0.5 6.68501C0.5 10.205 6.11 16.395 6.75 16.945C6.86823 17.0425 7.01673 17.0959 7.17 17.0959C7.32327 17.0959 7.47176 17.0425 7.59 16.945C8.23 16.395 13.84 10.205 13.84 6.68501C13.84 4.91602 13.1373 3.21948 11.8864 1.96861C10.6355 0.717745 8.93899 0.0150146 7.17 0.0150146H7.15ZM10.91 6.64502H9.91V9.71502C9.90498 9.77289 9.88855 9.82919 9.86166 9.88068C9.83477 9.93217 9.79795 9.97782 9.75333 10.015C9.7087 10.0522 9.65716 10.0802 9.60166 10.0973C9.54617 10.1145 9.48783 10.1205 9.43 10.115H5.07C4.95377 10.1235 4.83879 10.0865 4.74926 10.0119C4.65973 9.9373 4.60264 9.83087 4.59 9.71502V6.64502H3.43C3.33901 6.55325 3.28796 6.42925 3.28796 6.30001C3.28796 6.17078 3.33901 6.04678 3.43 5.95501L7.08 2.30502C7.10421 2.28179 7.13645 2.26882 7.17 2.26882C7.20354 2.26882 7.2358 2.28179 7.26 2.30502L10.91 5.95501C11.001 6.04678 11.052 6.17078 11.052 6.30001C11.052 6.42925 11.001 6.55325 10.91 6.64502Z"
                css={markerIconPath}
            />
        </g>
    );
};

const markerIconPath = (theme: Theme) => css`
    fill: ${theme.colors.primary};
`;

const backgroundCirclePath = (theme: Theme) => css`
    fill: ${theme.colors.secondary};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

interface IProps {
    x: number;
    y: number;
}

export const MapMarker: React.FC<IProps> = ({x, y}) => {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <path
                d="M7.24984 11.7247C10.0996 11.7247 12.4098 9.41445 12.4098 6.56466C12.4098 3.71487 10.0996 1.40466 7.24984 1.40466C4.40005 1.40466 2.08984 3.71487 2.08984 6.56466C2.08984 9.41445 4.40005 11.7247 7.24984 11.7247Z"
                css={backgroundCirclePath}
            />
            <path
                d="M7.15 0.0150146C5.38448 0.0203086 3.69306 0.725376 2.44652 1.97567C1.19997 3.22596 0.499992 4.91948 0.5 6.68501C0.5 10.205 6.11 16.395 6.75 16.945C6.86823 17.0425 7.01673 17.0959 7.17 17.0959C7.32327 17.0959 7.47176 17.0425 7.59 16.945C8.23 16.395 13.84 10.205 13.84 6.68501C13.84 4.91602 13.1373 3.21948 11.8864 1.96861C10.6355 0.717745 8.93899 0.0150146 7.17 0.0150146H7.15ZM10.91 6.64502H9.91V9.71502C9.90498 9.77289 9.88855 9.82919 9.86166 9.88068C9.83477 9.93217 9.79795 9.97782 9.75333 10.015C9.7087 10.0522 9.65716 10.0802 9.60166 10.0973C9.54617 10.1145 9.48783 10.1205 9.43 10.115H5.07C4.95377 10.1235 4.83879 10.0865 4.74926 10.0119C4.65973 9.9373 4.60264 9.83087 4.59 9.71502V6.64502H3.43C3.33901 6.55325 3.28796 6.42925 3.28796 6.30001C3.28796 6.17078 3.33901 6.04678 3.43 5.95501L7.08 2.30502C7.10421 2.28179 7.13645 2.26882 7.17 2.26882C7.20354 2.26882 7.2358 2.28179 7.26 2.30502L10.91 5.95501C11.001 6.04678 11.052 6.17078 11.052 6.30001C11.052 6.42925 11.001 6.55325 10.91 6.64502Z"
                css={markerIconPath}
            />
        </g>
    );
};

const markerIconPath = (theme: Theme) => css`
    fill: ${theme.colors.primary};
`;

const backgroundCirclePath = (theme: Theme) => css`
    fill: ${theme.colors.secondary};
`;
